import React, { Component } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import map from '../../img/bastings-map-v2.png';

export default class PageLocation extends Component {
	
	constructor(){
		super()
		this.state = {
			open: 			[false, false, false, false, false],
			maxHeight: 		[0, 0, 0, 0, 0],
			isActiveList:	null,
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
		
	handleToggle(_evt) {
	    _evt.preventDefault();  
	    let index = parseInt(_evt.currentTarget.getAttribute('data-index'));
	    let open = this.state.open;
	    if (open[index] === true) {
	    	open[index] = false;
	    } else {
		    open[index] = true;
	    }
	    this.setState({ open:open});
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
        
    handleResize() {
	    let maxHeight = this.state.maxHeight;
	    for (let i=0;i<2;i++) {
		  	if (this.accordionBody[i] && this.state.open[i] === true) {
		  		maxHeight[i] = this.accordionBodyInner[i].clientHeight;
	  		} else {
		  		maxHeight[i] = 0;
	  		}
  		}
  		this.setState({maxHeight : maxHeight});
  	}
  	
  	handleClick() {
	  	
  	}
	render() {
		
		let block = this.props.block;
		this.accordionBody = [];
    	this.accordionBodyInner = [];
    	return (
	    	
	    	<div id={block.id} className={'c-page__block c-page__block--text-space c-page__block--top-' + block.top_space + ' c-page__block--bottom-' + block.bottom_space + ' scope-' + block.background_colour}>
			    			    		
		    	<div className="c-page__block__inner">
	    	
			    	<div className="c-location">
			    	
			    		<div className="c-location__map">
			    			
			    			<div className="c-location__map__inner">
			    				
								<TransformWrapper>
								{({ zoomIn, zoomOut, resetTransform, ...rest }) => (
									<>
								<div className="c-location__map__tools">
									<button onClick={() => zoomIn()}>+</button>
									<button onClick={() => zoomOut()}>-</button>
									<button onClick={() => resetTransform()}>x</button>
								</div>
									<TransformComponent>
										<img width="2880" height="2092" src={map} alt="test" />
									</TransformComponent>
									</>
									)}
									
								</TransformWrapper>
							</div>
						</div>
											
						<div className="c-location__legend">
							
							<div className={'c-location__legend__item c-accordion ' + (this.state.open[0] ? 'state-open' : "")}>
					    
								<a href="#" className="c-location__legend__item__heading c-accordion__header" onClick={this.handleToggle} data-index="0" dangerouslySetInnerHTML={ {__html:'Parks'}}></a>
						    			    																											
								<div className="c-location__legend__item__body c-accordion__body" ref={e => (this.accordionBody[0] = e)} style={{maxHeight:this.state.maxHeight[0]+'px'}}>
								
									<div className="c-location__legend__item__body__inner c-accordion__body__inner" ref={e => (this.accordionBodyInner[0] = e)}>
																	
										<div className="scope-text scope-text--legend">
											<ul>
												<li dangerouslySetInnerHTML={ {__html:'<span>1. </span>Johnson Park Playground'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>2. </span>Merri Park'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>3. </span>Mayors Park'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>4. </span>Darling Gardens'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>5. </span>Edinburgh Gardens'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>6. </span>Yarra Bend Park'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>7. </span>Fairfield Park'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>8. </span>Fairfield Boathouse & Tea Gardens'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>9. </span>All Nations Park'}}></li>
											</ul>
										</div>
																			
									</div>
									
								</div>
						    
						    </div>
						    
						    
						    <div className={'c-location__legend__item c-accordion ' + (this.state.open[1] ? 'state-open' : "")}>
					    
								<a href="#" className="c-location__legend__item__heading c-accordion__header" onClick={this.handleToggle} data-index="1" dangerouslySetInnerHTML={ {__html:'Recreation & Entertainment'}}></a>
						    			    																											
								<div className="c-location__legend__item__body c-accordion__body" ref={e => (this.accordionBody[1] = e)} style={{maxHeight:this.state.maxHeight[1]+'px'}}>
								
									<div className="c-location__legend__item__body__inner c-accordion__body__inner" ref={e => (this.accordionBodyInner[1] = e)}>
																	
										<div className="scope-text scope-text--legend">
											<ul>
												<li dangerouslySetInnerHTML={ {__html:'<span>10. </span>Northcote Skate Park'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>11. </span>Collingwood Little Athletics Centre'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>12. </span>Collingwood Leisure Centre'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>13. </span>Fitzroy Victoria Bowling & Sports Club'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>14. </span>Fairfield Library'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>15. </span>Northcote Library'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>16. </span>Palace Westgarth Cinemas'}}></li>
											</ul>
										</div>
																			
									</div>
									
								</div>
						    
						    </div>
						    
						    
						    <div className={'c-location__legend__item c-accordion ' + (this.state.open[2] ? 'state-open' : "")}>
					    
								<a href="#" className="c-location__legend__item__heading c-accordion__header" onClick={this.handleToggle} data-index="2" dangerouslySetInnerHTML={ {__html:'Education'}}></a>
						    			    																											
								<div className="c-location__legend__item__body c-accordion__body" ref={e => (this.accordionBody[2] = e)} style={{maxHeight:this.state.maxHeight[2]+'px'}}>
								
									<div className="c-location__legend__item__body__inner c-accordion__body__inner" ref={e => (this.accordionBodyInner[2] = e)}>
																	
										<div className="scope-text scope-text--legend">
											<ul>
												<li dangerouslySetInnerHTML={ {__html:'<span>17. </span>Westgarth Primary School'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>18. </span>Northcote Primary School'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>19. </span>Northcote High School'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>20. </span>Santa Maria College'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>21. </span>St Joseph’s Primary School'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>22. </span>Fairfield Primary School'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>23. </span>Merri Creek Primary School'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>24. </span>Spensley Street Primary School'}}></li>
											</ul>
										</div>
																			
									</div>
									
								</div>
						    
						    </div>
						    
						    
						    <div className={'c-location__legend__item c-accordion ' + (this.state.open[3] ? 'state-open' : "")}>
					    
								<a href="#" className="c-location__legend__item__heading c-accordion__header" onClick={this.handleToggle} data-index="3" dangerouslySetInnerHTML={ {__html:'Retail, Shopping & Lifestyle'}}></a>
						    			    																											
								<div className="c-location__legend__item__body c-accordion__body" ref={e => (this.accordionBody[3] = e)} style={{maxHeight:this.state.maxHeight[3]+'px'}}>
								
									<div className="c-location__legend__item__body__inner c-accordion__body__inner" ref={e => (this.accordionBodyInner[3] = e)}>
																	
										<div className="scope-text scope-text--legend">
											<ul>
												<li dangerouslySetInnerHTML={ {__html:'<span>25. </span>Westgarth Shops'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>26. </span>Northcote Plaza'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>27. </span>Good Vibes Yoga'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>28. </span>Whimsy Gifts'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>29. </span>Northcote Wall, Bouldering'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>30. </span>Fitness XO Northcote Gym'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>31. </span>Westgarth Beauty'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>32. </span>Neighbourhood Books'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>33. </span>Australia Post'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>34. </span>Harvest Food Store'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>35. </span>CERES'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>36. </span>Peacock Inn Hotel'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>37. </span>Red Door Corner Store'}}></li>
											</ul>
										</div>
																			
									</div>
									
								</div>
						    
						    </div>
						    
						    
						    <div className={'c-location__legend__item c-accordion ' + (this.state.open[4] ? 'state-open' : "")}>
					    
								<a href="#" className="c-location__legend__item__heading c-accordion__header" onClick={this.handleToggle} data-index="4" dangerouslySetInnerHTML={ {__html:'Dining'}}></a>
						    			    																											
								<div className="c-location__legend__item__body c-accordion__body" ref={e => (this.accordionBody[4] = e)} style={{maxHeight:this.state.maxHeight[4]+'px'}}>
								
									<div className="c-location__legend__item__body__inner c-accordion__body__inner" ref={e => (this.accordionBodyInner[4] = e)}>
																	
										<div className="scope-text scope-text--legend">
											<ul>
												<li dangerouslySetInnerHTML={ {__html:'<span>38. </span>Hanami Izakaya'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>39. </span>The Merri Creek Tavern'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>40. </span>Terra Madre'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>41. </span>Westgarth Fish and Chips'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>42. </span>Primo Pizza'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>43. </span>Ferdinand'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>44. </span>Taxiboat'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>45. </span>Kelvin Bar'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>46. </span>Phil’s Westgarth Bakehouse'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>47. </span>VEX'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>48. </span>Nikos Fairfield'}}></li>
												<li dangerouslySetInnerHTML={ {__html:'<span>49. </span>Okami Japanese'}}></li>
											</ul>
										</div>
																			
									</div>
									
								</div>
						    
						    </div>
					    
		                </div>
					</div>
				</div>
			</div>
		)
	}
}
